import React, { useEffect, useMemo, useRef, useState } from 'react'
import includes from 'lodash/includes'
import { observer } from 'mobx-react-lite'
import { View, Text, StyleSheet } from 'react-native'
import { theme } from '@linqpal/common-frontend/'
import { useIframe } from '@linqpal/common-frontend/src/hooks/useIframe.web'
import { DataSecuredLabel } from '../../../../ui/atoms/DataSecuredLabel'
import { ICardEntryModel } from '@linqpal/models'
import { LegacyRef } from 'react'
import { useTranslation } from 'react-i18next'

interface ManualProps {
  onAction: (arg?) => void
  model: ICardEntryModel
}

const { commonColors } = theme

export const Manual: React.FC<ManualProps> = observer(({ onAction, model }) => {
  const { t } = useTranslation('global')
  const [error, setError] = useState('')
  const ref = useRef() as LegacyRef<View>
  console.log(typeof ref)
  const TABAPAY_IFRAME_BASE_URL =
    process.env.REACT_APP_LINQPAL_MODE !== 'prod'
      ? 'https://sso.sandbox.tabapay.com:8443'
      : 'https://sso.tabapay.com'
  const TABAPAY_IFRAME_URL =
    process.env.REACT_APP_LINQPAL_MODE !== 'prod'
      ? `${TABAPAY_IFRAME_BASE_URL}/SSOLinqPay.html`
      : `${TABAPAY_IFRAME_BASE_URL}/SSOBlueTapeISO.html`
  const src = useMemo(
    () => `${TABAPAY_IFRAME_URL}?${new Date().getTime()}`,
    [TABAPAY_IFRAME_URL],
  )
  useIframe({ ref, src, id: 'sso' })

  const pfReceivedMessage = (event) => {
    setError('')
    console.log(event.origin)
    if (
      event.origin === TABAPAY_IFRAME_BASE_URL ||
      includes(event.origin, TABAPAY_IFRAME_BASE_URL)
    ) {
      if (event.data !== 'Close') {
        if (event.data.slice(0, 7) === 'Error: ') {
          setError(event.data)
        } else {
          const cardData = event.data.split('|')
          if (cardData.length === 3) {
            model.setValue('binNumber', cardData[0])
            model.setValue('expirationDate', cardData[1])
            model.setValue('cardToken', cardData[2])
            onAction()
          } else {
            console.log(event.data)
            setError('Error: Unable to process the details, please try later')
          }
        }
      } else {
        // Close or Cancel
        console.log('close ')
        onAction(true)
      }
    }
  }

  useEffect(() => {
    window.addEventListener('message', pfReceivedMessage, false)
    return () => {
      window.removeEventListener('message', pfReceivedMessage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <View>
      {!!error && <Text style={styles.errorText}>{error}</Text>}
      <View
        ref={ref}
        style={{
          position: 'relative',
          paddingTop: 20,
          minHeight: 370,
          overflow: 'hidden',
        }}
      />
      <View
        style={{
          paddingHorizontal: 16,
        }}
      >
        <Text style={styles.infoText}>
          {t('AddCard.card-details-are-tokenized')}
        </Text>
        <DataSecuredLabel />
      </View>
    </View>
  )
})

export default {
  title: 'Type in your card number',
  component: Manual,
  next: 'CardholderDetails',
}

const styles = StyleSheet.create({
  infoText: {
    fontSize: 12,
    fontWeight: '400',
    textAlign: 'center',
    color: '#2f4858',
    opacity: 0.6,
    lineHeight: 20,
    marginBottom: 6,
  },
  errorText: {
    color: commonColors.accent,
    fontSize: 18,
    marginVertical: 15,
  },
})
